(function () {
  if (window.watcherayUpsellsInstalled) return;
  window.watcherayUpsellsInstalled = true;

  function money(amount, box) {
    return '€' + new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(amount / 100);
  }
  function selected(box) {
    return [...box.querySelectorAll('input[data-addon-id]:checked')];
  }
  const choices = new Map();
  const hydrated = new WeakSet();
  function remember(box) {
    const info = box.closest('.product-info');
    choices.set(box.dataset.productId, {
      size: info?.querySelector('[data-wr-size] input:checked')?.value,
      addons: selected(box).map(input => input.dataset.addonId)
    });
  }
  function hydrate() {
    document.querySelectorAll('[data-wr-upsells]').forEach(box => {
      if (hydrated.has(box)) return;
      hydrated.add(box);
      const saved = choices.get(box.dataset.productId);
      if (!saved) return;
      const info = box.closest('.product-info');
      if (saved.size) {
        const size = [...info.querySelectorAll('[data-wr-size] input')].find(input => input.value === saved.size);
        if (size) {
          size.checked = true;
          info.querySelector('[data-wr-size-selected]').textContent = saved.size.replace(' mm', '');
        }
      }
      box.querySelectorAll('input[data-addon-id]').forEach(input => input.checked = saved.addons.includes(input.dataset.addonId));
      update(box);
    });
  }
  function update(box) {
    const total = Number(box.dataset.basePrice) + selected(box).reduce((sum, input) => sum + Number(input.dataset.addonPrice), 0);
    box.querySelector('[data-wr-total]').textContent = money(total, box);
    const price = box.closest('.product-info')?.querySelector('.product-info__price sale-price .cvc-money');
    if (price) price.textContent = money(total, box);
    const compare = box.closest('.product-info')?.querySelector('.product-info__price compare-at-price');
    if (compare) compare.hidden = selected(box).length > 0;
    const savings = box.closest('.product-info')?.querySelector('.product-info__price on-sale-badge');
    if (savings) savings.hidden = selected(box).length > 0;
  }
  document.addEventListener('change', event => {
    const size = event.target.closest('[data-wr-size]');
    if (size) size.querySelector('[data-wr-size-selected]').textContent = event.target.value.replace(' mm', '');
    const box = event.target.closest('[data-wr-upsells]');
    const current = box || size?.closest('.product-info')?.querySelector('[data-wr-upsells]');
    if (current) {
      update(current);
      remember(current);
    }
  });
  document.addEventListener('variant:change', event => {
    const info = event.target.closest('.product-info');
    const box = info?.querySelector('[data-wr-upsells]');
    if (box && event.detail?.variant?.price != null) {
      box.dataset.basePrice = event.detail.variant.price;
      update(box);
    }
  });
  async function addToCart(event, button) {
    const form = button.closest('form[is="product-form"]');
    if (!form) return;
    const box = [...document.querySelectorAll('[data-wr-upsells]')].find(node => node.dataset.formId === form.getAttribute('id'));
    if (!box) return;
    const addons = selected(box);
    event.preventDefault();
    event.stopImmediatePropagation();
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    const error = box.querySelector('[data-wr-error]');
    error.hidden = true;
    if (!id || !Number.isInteger(quantity) || quantity < 1) {
      error.textContent = box.dataset.errorChoice;
      error.hidden = false;
      return;
    }
    button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';
    const watch = {id, quantity};
    const size = data.get('properties[Size (mm)]');
    if (size) watch.properties = {'Size (mm)': size};
    const items = [watch, ...addons.map(input => ({id: Number(input.dataset.addonId), quantity: input.hasAttribute('data-rotor-upgrade') ? quantity : 1}))];
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items})
      });
      if (!response.ok) throw new Error((await response.json()).description || box.dataset.errorAdd);
      window.location.assign(root + 'cart');
    } catch (reason) {
      error.textContent = reason.message || box.dataset.errorAdd;
      error.hidden = false;
      button.disabled = false;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wr-add-to-cart]');
    if (button) addToCart(event, button);
  }, true);
  hydrate();
  new MutationObserver(hydrate).observe(document.body, {childList: true, subtree: true});
})();
